import { useEffect } from 'react'
import { motion } from 'motion/react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import animationVariants from '../../lib/animationVariants'

export default function Family () {
  const location = useLocation()
  const { direction } = location.state || {}

  useEffect(() => {
    if (location.state) {
      location.state.background = '#1F1F1F'
    } else {
      location.state = {
        background: '#1F1F1F'
      }
    }
  }, [location])

  return (
    <motion.div className='w-100 h-100' variants={animationVariants[direction]} initial='hidden' animate='visible' exit='exit'>
      <Container fluid id='family' className='w-100 h-100'>
        <Row as='section' className='h-100'>
          <Col className='d-flex flex-column'>
            <Row>
              <Col>
                <p className='intro-text'>
                  The foundation of Ames Construction began with a family who dreamed big, followed opportunities, and
                  passed on the values of hard work, integrity and perseverance to their children.
                </p>
              </Col>
            </Row>
            <Row className='flex-grow-1 p-3'>
              <Col className='flex-container'>
                <div>
                  <p>Touch a name to learn more about them.</p>
                  <div className='first d-flex'>
                    <Link to='/ames-family-history/john_and_eliza_ames' state={{ direction: 'up' }}>
                      <img src='/images/JohnElizaAmes_2X.jpg' alt='' width='254' height='127' />
                      <span>John Stephen Ames &amp; Eliza (Levell) Ames</span>
                    </Link>
                    <Link to='/ames-family-history/george_and_prudence_ames' state={{ direction: 'up' }}>
                      <img src='/images/GeorgePrudenceAmes_2X.jpg' alt='' width='185' height='127' />
                      <span>George Arthur Ames &amp; Prudence (Hawbaker) Ames</span>
                    </Link>
                    <Link to='/ames-family-history/chester_and_ruby_ames' state={{ direction: 'up' }}>
                      <img src='/images/ChesterRubyAmes1_2X.jpg' alt='' width='185' height='127' />
                      <span>Chester “Chet” Ames &amp; Ruby Belle (Reisger) Ames</span>
                    </Link>
                    <div className='arrow-wrapper'>
                      <div className='arrow-line' />
                      <div className='arrow arrow-right' />
                    </div>
                  </div>
                </div>
                <div className='descendant'>
                  <Link to='/ames-family-history/dick_ames' state={{ direction: 'up' }}>
                    <img src='/images/DickAmes1_2X.jpg' alt='' />
                    <span>Richard John “Dick” Ames</span>
                  </Link>
                  <span>
                    <img src='/images/BeverlyAnnAmes_2X.jpg' alt='' />
                    <span>Beverly Ann Ames – deceased at 18 months</span>
                  </span>
                  <Link to='/ames-family-history/audrey_ames_brennan' state={{ direction: 'up' }}>
                    <img src='/images/AudreyElaineAmes_2X.jpg' alt='' />
                    <span>Audrey Elaine Ames</span>
                  </Link>
                  <Link to='/ames-family-history/mary_ellen_ames' state={{ direction: 'up' }}>
                    <img src='/images/MaryEllenAmes_2X.jpg' alt='' />
                    <span>Mary Ellen Ames</span>
                  </Link>
                  <Link to='/ames-family-history/peggy_lou_ames' state={{ direction: 'up' }}>
                    <img src='/images/PeggyLouAmes_2X.jpg' alt='' />
                    <span>Peggy Lou Ames</span>
                  </Link>
                  <Link to='/ames-family-history/butch_ames' state={{ direction: 'up' }}>
                    <img src='/images/ButchAmes1_2X.jpg' alt='' />
                    <span>Raymond George “Butch” Ames</span>
                  </Link>
                  <Link to='/ames-family-history/john_alvin_ames' state={{ direction: 'up' }}>
                    <img src='/images/JohnAmes1_2X.jpg' alt='' />
                    <span>John Alvin Ames</span>
                  </Link>
                  <Link to='/ames-family-history/tom_ames' state={{ direction: 'up' }}>
                    <img src='/images/TomAmes1_2X.jpg' alt='' />
                    <span>Thomas Gordon “Tom” Ames</span>
                  </Link>
                  <Link to='/ames-family-history/ron_ames' state={{ direction: 'up' }}>
                    <img src='/images/RonAmes1_2X.jpg' alt='' />
                    <span>Ronald Lee “Ron” Ames</span>
                  </Link>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </motion.div>
  )
}
